import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { formatArrivalDate } from '../../../../../../utils/Functions';
import { ItineraryService } from '../../../../../../shared/itinerary.service';
import { RestService } from '../../../../../../shared/rest.service';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { ConfirmationModalComponent } from '../../../../../../shared/modals/confirmation-modal/confirmation-modal.component';
import { CurrencyConverterPurePipe } from 'app/shared/currency-converter-pure.pipe';
import { UserService } from 'app/pages/com.usblick.common/auth/user.service';
import { HttpErrorResponse } from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';
import { NotificationService } from 'app/shared/notifications/notification.service';

@Component({
  selector: 'usb-item-flight',
  templateUrl: './item-flight.component.html',
  styleUrls: ['./item-flight.component.scss'],
  providers: [CurrencyConverterPurePipe]
})
export class ItemFlightComponent implements OnInit {
  @Input() dato: any;
  @Input() isCheckIn: boolean;
  @Input() partialReserve: boolean;
  @Input() clientSetting: any;
  @Input() permissions: any;
  @Input() currencies: any;
  @Input() currencyAgency: any;
  @Output() itemToPartial = new EventEmitter<number>();
  @Output() itemDelete = new EventEmitter<any>();
  @Output() delete = new EventEmitter<string>();
  @Output() cancel = new EventEmitter<string>();

  public formatDate = formatArrivalDate;
  bsModalRef?: BsModalRef;

  constructor(
    private itineraryService: ItineraryService,
    private currencyPipe: CurrencyConverterPurePipe,
    private restService: RestService,
    public userService: UserService,
    private modalService: BsModalService,
    private ngxSpinner: NgxSpinnerService,
    private notificationService: NotificationService,
  ) { }

  ngOnInit(): void { console.log(this.dato)}

  // El backend persiste arrivalDate/departureDate con la misma convención
  // que hoteles (arrival = fecha más temprana/ida, departure = más
  // tardía/vuelta) y sobrescribe el departureDate propio del producto — por
  // eso acá se usan esos dos campos y no item.departureDate/item.returnDate.
  isRoundTrip(): boolean {
    return !!this.dato?.arrivalDate && !!this.dato?.departureDate && this.dato.arrivalDate !== this.dato.departureDate;
  }

  // Vuelo elegido "Por tramos": cada tramo es su propio item, tageado por
  // FlyProductService con item.direction ('IDA'/'VUELTA'/'Tramo N').
  getDirectionLabel(): string {
    if (!this.dato?.direction) {
      return '';
    }
    if (this.dato.direction === 'IDA') { return 'Ida'; }
    if (this.dato.direction === 'VUELTA') { return 'Vuelta'; }
    return this.dato.direction;
  }

  getPrice(item: any): number {
    if (item.status_id === 5) {
      return 0;
    }

    let price: number;

    if (!item.isPendigApprovePay && !item.isPaidAgency && !item.isPaidProvider) {
      price = item.netPriceAgent ?? item.pricing?.totalPriceProf ?? item.totalPriceProf;
      price = this.currencyPipe.transform(
        price,
        item?.currency,
        this.currencyAgency?.code,
        this.currencies
      );
    }

    if (item.isPendigApprovePay || item.isPaidAgency || item.isPaidProvider) {
      if (item.converted_amounts) {
        price = item.converted_amounts.netPriceAgent;
      } else {
        price = item.netPriceAgent ?? item.pricing?.totalPriceProf ?? item.totalPriceProf;
      }
    }

    return price;
  }

  toPartialReserve(event, item: any): void {
    if (event.target.checked) {
      this.itineraryService.updateItineraryPartial(item);
      this.itemToPartial.emit(1);
    } else {
      this.itineraryService.updateItineraryPartial(item, true);
      this.itemToPartial.emit(-1);
    }
  }

  removeItem(item: any): void {
    let message = '';

    if (item.status_id === 1 || item.status_id === 5) {
      message = '¿Esta seguro de eliminar el producto?';
    }
    if (item.status_id === 2) {
      message = '¿Esta seguro de cancelar el producto?';
    }

    const initialState: ModalOptions = {
      initialState: {
        title: item.status_id === 2 ? 'Cancelar' : 'Eliminar',
        message: message.replace(/\?/g, '?<br />'),
        icon: 'assets/icons/itinerary-detail/04-01.svg'
      }
    };

    this.bsModalRef = this.modalService.show(ConfirmationModalComponent, initialState);
    const confirmSubscription = this.bsModalRef.content.confirmResult.subscribe((result: boolean) => {
      if (result) {
        if (item.status_id === 1 || item.status_id === 5) {
          this.deleteItem(item);
        }
        if (item.status_id === 2) {
          this.cancelReservation(item);
        }
      }
      confirmSubscription.unsubscribe();
    });
  }

  deleteItem(item: any): void {
    this.itineraryService.remove(item !== undefined ? item : item);
    setTimeout(() => {
      this.delete.emit(item.id);
      this.userService.updateProductsPrices(item.itinerary_id);
    }, 1000);
  }

  cancelReservation(item: any): void {
    this.ngxSpinner.show();

    const cancelData: any = {
      providerId: item?.providerId,
      reservationLocator: item?.resultReserve?.providerReservationId,
    };

    this.restService.doPut('app', `products/cancelReservation/${item?.itinerary_id}`, cancelData).subscribe({
      next: () => {
        this.ngxSpinner.hide();
        this.notificationService.success('Su producto fue cancelado con éxito');
        this.cancel.emit(item.id);
        this.itineraryService.updateItinerary(this.userService.itineraryActive[0], false);
      },
      error: (error: HttpErrorResponse) => {
        this.ngxSpinner.hide();
        this.notificationService.error('Ocurrió un error');
        console.log(error);
      }
    });
  }
}
